import React, { useState } from "react";
import { CheckoutInputV2 } from "../../../CheckoutInputV2";
import { InputContainer } from "../../../InputContainer";

import { styled } from "@mui/material";
import { MOBILE_SCREEN_SIZE } from "@brandclub/common-ui";
import { buildAddressString } from "../../../..";
import StoreAddressAutocompleteInput, {
  AutocompleteAddress,
} from "./CheckoutAddressAutocompleteInput";

const Container = styled("div")(({ theme }) => ({
  marginTop: 44,
  [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    marginTop: 20,
  },
  ".title": {
    fontSize: 20,
    fontWeight: 600,

    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 14,
    },
  },
}));

const AddressForm = ({
  firstName,
  setFirstName,
  lastName,
  setLastName,
  address1,
  setAddress1,
  address2,
  setAddress2,
  city,
  setCity,
  state,
  setState,
  zipCode,
  setZipCode,
}: {
  firstName?: string;
  setFirstName: (firstName: string) => void;
  lastName?: string;
  setLastName: (lastName: string) => void;
  address1?: string;
  setAddress1: (address1: string) => void;
  address2?: string;
  setAddress2: (address2: string) => void;
  city?: string;
  setCity: (city: string) => void;
  state?: string;
  setState: (state: string) => void;
  zipCode?: string;
  setZipCode: (zipCode: string) => void;
}) => {
  const [open, setOpen] = useState(false);

  const fullAddressString = buildAddressString({
    address1,
    address2,
    city,
    state,
    zipCode,
  });

  return (
    <Container>
      <InputContainer>
        <CheckoutInputV2
          label={"First Name"}
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
        <CheckoutInputV2
          label={"Last Name"}
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
      </InputContainer>
      <InputContainer>
        <StoreAddressAutocompleteInput
          searchTerm={address1 || ""}
          selectAddressCallback={(address: AutocompleteAddress) => {
            setAddress1(address?.line1 || "");
            setCity(address?.city || "");
            setState(address?.state || "");
            setZipCode(address?.zip || "");
            setOpen(true);
          }}
          renderInput={(param: any) => (
            <CheckoutInputV2
              placeholder="Begin typing to search"
              label={"Street address"}
              value={open ? address1 : fullAddressString}
              onChange={(e) => setAddress1(e.target.value)}
              {...param}
              InputProps={{
                ...param.InputProps,
              }}
              inputProps={{
                ...param.inputProps,
                value: open ? address1 : fullAddressString,
              }}
            />
          )}
        />
      </InputContainer>
      {open ? (
        <div>
          <InputContainer>
            <CheckoutInputV2
              label={"Suite, Apartment, C/O"}
              value={address2}
              onChange={(e) => setAddress2(e.target.value)}
            />
            <CheckoutInputV2
              label={"City"}
              value={city}
              onChange={(e) => setCity(e.target.value)}
            />
          </InputContainer>
          <InputContainer>
            <CheckoutInputV2
              label={"State"}
              value={state}
              onChange={(e) => setState(e.target.value)}
            />
            <CheckoutInputV2
              label={"Zip Code"}
              value={zipCode}
              onChange={(e) => setZipCode(e.target.value)}
            />
          </InputContainer>
        </div>
      ) : null}
    </Container>
  );
};

export default AddressForm;
